import lazyWithRetry from 'tools/lazyWithRetry';

const component = lazyWithRetry(() => import(
	/* webpackChunkName: "DressingDashboardPage" */
	'pages/vehicle/Dressing/DressingDashboardPage'));

export default [{ component, exact: true, path: '/dressings/:dressingId' }];